export default __webpack_public_path__ + "035cb93d88fd82544354b7ae4d54e6d7.png";